import { Component, OnInit } from '@angular/core';
import { SuggestionService } from 'src/app/services/suggestion/suggestion.service';

@Component({
    selector: 'xqnr-suggestion-notify-float',
    templateUrl: './suggestion-notify-float.component.pug',
    styleUrls: ['./suggestion-notify-float.component.scss'],
    standalone: false
})
export class SuggestionNotifyFloatComponent implements OnInit {
  constructor(
    public suggestions: SuggestionService
  ) {}

  ngOnInit(): void {}
}
